import React from 'react'

const useFirebase = () => {
  return (
    <div>useFirebase</div>
  )
}

export default useFirebase